import { Component } from '@theme/component';

/**
 * Product tabs component (Overview / Features / Technology / Size & Fit /
 * Comparison / FAQ). Tabs are data-driven from the product's
 * custom.product_tabs metafield — see sections/product-tabs.liquid.
 *
 * @extends {Component<{tabButtons: HTMLButtonElement[], tabPanels: HTMLElement[]}>}
 */
class ProductTabsComponent extends Component {
  requiredRefs = ['tabButtons', 'tabPanels'];

  /**
   * @param {{tab: number}} data
   */
  selectTab(data) {
    const index = data.tab;
    const { tabButtons, tabPanels } = this.refs;

    tabButtons.forEach((button, i) => {
      const selected = i === index;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });

    tabPanels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}

if (!customElements.get('product-tabs-component')) {
  customElements.define('product-tabs-component', ProductTabsComponent);
}
